export default "__VITE_ASSET__b656ab97__"